/* eslint-disable react/display-name */
/* /src/routes/privateRoute.jsx */
import React from "react";
import { Route } from "react-router-dom";
import { AppConsumer } from "./providers/appProvider";

export const PrivateRoute = ({ component, ...rest }) => {
    const renderFn = (Component) => (props) => (
        <AppConsumer>
            {({ isAuthenticated, signinRedirect }) => {
                if (!!Component && isAuthenticated()) {
                    return <Component {...props} />;
                } else {
                    signinRedirect();
                    return <span>...Завантаження...</span>;
                }
            }}
        </AppConsumer>
    );

    return <Route {...rest} render={renderFn(component)} />;
};